var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PrintedOrders.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-55b5184a\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PrintedOrders.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue/src/views/orders/PrintedOrders.vue
// module id = 480
// module chunks = 0